import React from "react";
import FlightList from "../components/FlightList";
import PassengerForm from "../components/PassengerForm";
import BookingSummary from "../components/BookingSummary";

function Dashboard({
  selectedFlight,
  passenger,
  setPassenger,
  bookingConfirmed,
  onSelectFlight,
  onConfirm,
  onReset,
}) {
  return (
    <div className="content-grid">
      <div className="primary-panel">
        <FlightList
          onSelectFlight={onSelectFlight}
          selectedFlight={selectedFlight}
        />
      </div>
      <div className="secondary-panel">
        <PassengerForm passenger={passenger} setPassenger={setPassenger} />
        <BookingSummary
          flight={selectedFlight}
          passenger={passenger}
          confirmed={bookingConfirmed}
          onConfirm={onConfirm}
          onReset={onReset}
        />
      </div>
    </div>
  );
}

export default Dashboard;